import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient } from '@angular/common/http';
import { CommonFunction } from '../helpers/commonFunction';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharerService {

  constructor(private httpService: HttpService,private httpClient: HttpClient,private commonFuction : CommonFunction) { }
  getSharerList(companyDetails){
    var request = {
        URL: "dataTable/sharerDetails",
        DATA: companyDetails
    }
    return this.httpService.post(request);
}
getAllSharerList(companyDetails){
    var request = {
        URL: "dataTable/getAllSharerList",
        DATA: companyDetails
    }
    return this.httpService.post(request);
}

addSharer(newSharer) {
    var newSharer_string = JSON.stringify(newSharer)
    var enc_newSharer = this.commonFuction.encrypt(newSharer_string);
     var wrappedData = {
        wrappedData : enc_newSharer
    }

    var request = {
        URL: "sharer/add",
        DATA: wrappedData
    }
    return this.httpService.post(request).map((res:any)=>{
        var dec = this.commonFuction.decrypt((res.encryptedResponse))
        // console.log(JSON.parse(dec.encryptedResponse))
        return JSON.parse(dec);
    }).catch((error)=>{
        return error;
    });      

    // var request = {
    //     URL: "sharer/add",
    //     DATA: newSharer
    // }
    // console.log("request",request)
    // return this.httpService.post(request);        
}

removeSharer(SharerId: string){
    var request = {
        URL:  'sharer/update/'+SharerId,
        DATA: SharerId
    }
    return this.httpService.get(request);        
}

CheckUniqeEmailWithInCmp(email_id){
    var request = {
        URL: "sharer/checkUniqueEmail",
        DATA: {email:email_id}
    }
    return this.httpService.post(request);     
}

updateSharer(newSharer){
    var request = {
        URL:  'agenda/edit/'+newSharer._id,
        DATA: newSharer
    }
    return this.httpService.post(request);        
}

editSharer(sharerID: string) {

    var request = {
        URL: 'sharer/edit/' + sharerID
    }
    return this.httpService.get(request);
}
approveSharer(sharerID: string) {

    var request = {
        URL: 'sharer/addApprove/' + sharerID
    }
    return this.httpService.get(request);
}
deleteSharer(sharerID: string) {
    var request = {
        URL: "sharer/delete/"+sharerID,
      
    }
    return this.httpService.get(request);        
}

getSharerHistory(sharerID: string) {
    var request = {
        URL: "sharer/history/"+sharerID,
      
    }
    return this.httpService.get(request);        
}

// getClientIp(): Observable<any> {
//     const URL = 'https://jsonip.com';
//     return this.httpClient.get(URL);       
// }
getClientIp(): Observable<any> {
  const URL = 'https://api64.ipify.org?format=json';
  return this.httpClient.get(URL);      
}

downloadDoc(filename){
    var request = {
        URL: "upsi/sharerDoc/"+ filename,
    }
    return this.httpService.get(request);
}

getAllRecipientList(companyDetail){
    var request = {
        URL: "dataTable/getAllRecipientList",
        DATA: companyDetail
    }
    return this.httpService.post(request);
}


getRecipientList(companyDetail){
    var request = {
        URL: "dataTable/recipientDetails",
        DATA: companyDetail
    }
    return this.httpService.post(request);
}
}
